export default function validateClass(knownClasses, classes) {
  classes.forEach(c => {
    if (!knownClasses.includes(c)) {
      throw new Error(`Unknown class ${c}`)
    }
  })
}
